<template>
    <div class="topics-container">
            <TitlePart text="Scopes & Topics"/>
            <div class="update-content">
                <h3>Will update soon...</h3>
            </div>
        </div>
</template>

<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>